import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  @Input() buttons: any[] = [];
  @Input() title = '';
  @Input() disabled = false;
  @Input() message = '';
  @Input() alert = {
    message: '',
    type: '',
  };
  modal = inject(NgbActiveModal);
}
